import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetBidNegotiationServiceCodesQuery, VehicleTypeFilter } from 'generated/graphql'

import { NegotiationOverviewFilterValues } from './NegotiationOverviewFilterCriteria'
import { useNegotiationOverviewQueryInput } from './useNegotiationOverviewQueryInput'

export const NegotiationOverviewServiceCodeAutocomplete = () => {
  const { control } = useFormContext<NegotiationOverviewFilterValues>()
  const { start, end } = useNegotiationOverviewQueryInput()

  const { data } = useGetBidNegotiationServiceCodesQuery({
    variables: { input: { start, end, vehicleType: VehicleTypeFilter.All } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.bidNegotiationServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={2}
      size='small'
      sx={{ minWidth: 180 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
